export const requiresWholeQuantity = (unit: unknown): boolean =>
    typeof unit === 'string' && ['ea', 'each'].includes(unit.trim().toLowerCase())

export function wholeQuantityError(value: unknown): string | null {
    if (!value || typeof value !== 'object' || Array.isArray(value)) { return null }
    const { unit, amount } = value as { unit?: unknown; amount?: unknown }
    return requiresWholeQuantity(unit) && amount != null &&
        (typeof amount !== 'number' || !Number.isInteger(amount))
        ? 'EA quantities must be whole numbers.' : null
}
